module.exports = __webpack_public_path__ + "static/img/a12.e9c47e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a12.jpg
// module id = 430
// module chunks = 1